import { createSlice } from "@reduxjs/toolkit";
import { userAsync } from "./operations";
import { AuthState } from "./state";

const initialState: AuthState = {
  user: "",
};

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(userAsync.pending, () => {
      /* Empty Function */
    });
    builder.addCase(userAsync.fulfilled, (state, action) => {
      const { payload } = action;
      state.user = payload.orderCode;
    });
    builder.addCase(userAsync.rejected, () => {
      /* Empty Function */
    });
  },
});
export default authSlice.reducer;
